import { render, staticRenderFns } from "./ModernSidebar.vue?vue&type=template&id=3833c36e&scoped=true&"
import script from "./ModernSidebar.vue?vue&type=script&lang=js&"
export * from "./ModernSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833c36e",
  null
  
)

export default component.exports